<template>
  <div v-loading.fullscreen.lock="loading">
    <!-- 商品废弃 -->
    <el-dialog :title="$t('message.wasteGoods')" :close-on-click-modal="false"
      :visible.sync="$parent.wasteGoodsDialogVisible" width="1852px" center>
      <div class="content">
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!--  库位-->
            <li class="flex15">
              {{ $t("message.location") }}
            </li>
            <!--  装箱信息 -->
            <!-- <li class="flex18">
              {{ $t("message.packingInformation") }}
            </li> -->

            <!--  订单号 -->
            <li class="flex15">
              {{ $t("message.orderbianhao") }}
            </li>
            <!-- 番号 -->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 类型 -->
            <li>{{ $t("message.type") }}</li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!--交易号  -->
            <li class="flex15">{{ $t("message.transactionNumber") }}</li>
            <!--库位数量  -->
            <li>{{ $t("message.numberOfStorageLocations") }}</li>
            <!-- 废弃数量 -->
            <li>{{ $t("message.quantityOfWaste") }}</li>
            <!--实有备品数量  -->
            <li>{{ $t("message.actualQuantityOfSparePart") }}</li>
            <!-- 联系截图 -->
            <li class="flex15">{{ $t("message.contactScreenshot") }}</li>
            <!-- 转入原因备注 -->
            <li class="flex15">
              {{ $t("message.remarksOnReasonsForTransfer") }}
            </li>
          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <li class="flex05">{{ item.rowNumber }}</li>
            <!--  库位-->
            <li class="flex15">
              <div class="template">
                <p>{{ item.grid_number.split("】-")[0] }}】-</p>
                <p style="color: #fa5058">
                  {{ item.grid_number.split("】-")[1] }}
                </p>
              </div>
            </li>
            <!--  装箱信息 -->
            <!-- <li class="flex18">
              <div class="template">
                <p v-for="(items, indexs) in item.order_box" :key="indexs">
                  {{ items.order_sn }}-
                  <span style="color: #fa5058">{{ items.box_no }}</span>
                </p>
              </div>
            </li> -->

            <!--  订单编号 -->
            <li class="flex15">
              <div class="template">
                <p>
                  {{ item.order_purchase.order_sn }}
                </p>
                <p>{{ item.order_purchase.order.user.realname }}</p>
              </div>
            </li>
            <!-- 番号 -->
            <li class="flex05">
              {{ item.order_purchase.order_detail.sorting }}
            </li>
            <!--照片-->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="`https://detail.1688.com/offer/${item.order_purchase.order_detail.goods_id}.html`"
                  target="_blank" slot="reference">
                  <img :src="item.order_purchase.order_detail.pic" alt="" style="width: 60px; height: 60px" />
                </a>
              </el-popover>
            </li>
            <!-- 类型 -->
            <li>
              <div class="template">
                <p>{{ item.order_purchase.order_detail.from_platform }}</p>
                <!-- 商品id -->
                <p>
                  {{ $t("message.goodsID") }}:{{
                    item.order_purchase.order_detail.goods_id
                  }}
                </p>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_purchase
                      .order_detail.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_purchase
                      .order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--交易号  -->
            <li class="flex15">{{ item.order_purchase.purchase_no }}</li>
            <!--库位数量  -->
            <li>{{ type == "add" ? item.num : item.grid_stock }}</li>
            <!-- 废弃数量 -->
            <li>
              <el-input v-model="item.can_discard_num" onkeyup.native="value=value.replace(/^(0+)|[^\d.]+/g,'')"
                type="number" @input="maxNum(item, index)" onfocus="this.select()" v-if="type == 'add'"></el-input>
              <el-input v-model="item.num" onkeyup.native="value=value.replace(/^(0+)|[^\d.]+/g,'')" type="number"
                @input="maxNum1(item, index)" onfocus="this.select()" v-else></el-input>
            </li>
            <!--实有备品数量  -->
            <li>
              <el-input v-model="item.real_num" onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" type="number"
                onfocus="this.select()"></el-input>
            </li>
            <!-- 联系截图 -->
            <li class="flex15">
              <div class="imgList">
                <div class="imgs" v-for="(imgs, imgIndex) in item.images" :key="imgIndex"
                  @click="getIndex(index, imgIndex)">
                  <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="imgs" :src="imgs" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </div>
            </li>
            <!-- 转入原因备注 -->
            <li class="flex15">
              <el-input v-model="item.reason" type="textarea" :placeholder="$t('message.remarksOnReasonsForTransfer')"
                rows="6" resize="none"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--重置-->
        <el-button @click="$parent.wasteGoodsDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!--保存-->
        <el-button type="primary" @click="toDiscardApply" v-if="type == 'add'">{{ $t("message.ok") }}</el-button>
        <!--保存-->
        <el-button type="primary" @click="toDiscardUpdate" v-else>{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    list: { type: Array },
    type: { type: String }, //判断是新增add还是修改edit
  },
  data() {
    return {
      uploadUrl: "https://jpapi.rakumart.cn/api/common/uploadFile",
      indexs: {},
      loading: false,
    };
  },
  created() {
    console.log(this.list);
  },
  methods: {
    // 图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      this.loading = true;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        this.loading = false;
      }
      return isJPG || isPNG;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      this.loading = false;
      if (file.code != 0) return this.$message.error(file.msg);
      this.$message.success(file.msg);
      this.list[this.indexs.item_i].images[this.indexs.imgs_i] = file.data;

      this.$forceUpdate();
    },
    // 获取图片索引
    getIndex(index, imgIndex) {
      this.indexs = {
        item_i: index,
        imgs_i: imgIndex,
      };
    },
    // 最大废弃值
    maxNum(item, i) {
      if (item.can_discard_num > item.num) {
        this.list[i].can_discard_num = item.num;
        this.$message.error("废弃数量不能大于库位数量");
      }
    },
    maxNum1(item, i) {
      if (item.num > item.grid_stock) {
        this.list[i].num = item.grid_stock;
        this.$message.error("废弃数量不能大于库位数量");
      }
    },
    // 申请废弃
    toDiscardApply() {
      let datas = {
        list: [],
      };
      for (let i = 0; i < this.list.length; i++) {
        if (!this.list[i].can_discard_num) {
          this.$alert("废弃数量不能为0，不能为空", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (this.list[i].real_num === "") {
          this.$alert("实有备品数量不能为空", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
      }
      this.list.forEach((item) => {
        datas.list.push({
          wms_stock_id: item.id,
          num: item.can_discard_num,
          real_num: item.real_num,
          reason: item.reason,
          images: item.images,
        });
      });
      this.$api.warehouseApi.toDiscardApply(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.wasteGoodsDialogVisible = false;
        this.$parent.handleClick();
      });
    },
    //修改废弃
    toDiscardUpdate() {
      let datas = {
        list: [],
      };
      for (let i = 0; i < this.list.length; i++) {
        if (!this.list[i].num) {
          this.$alert("废弃数量不能为0，不能为空", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (this.list[i].real_num === "") {
          this.$alert("实有备品数量不能为空", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
      }
      this.list.forEach((item) => {
        datas.list.push({
          id: item.id,
          num: item.num,
          real_num: item.real_num,
          reason: item.reason,
          images: item.images,
        });
      });

      this.$api.warehouseApi.toDiscardUpdate(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.wasteGoodsDialogVisible = false;
        this.$parent.toDiscardList();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;

  .table {
    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex18 {
      flex: 1.8;
    }

    ul {
      padding: 20px 0;

      /deep/.el-input {
        width: 80%;
      }

      .template {
        width: 100%;
        text-align: center;
      }
    }

    .imgList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-left: 5px;

      .imgs {
        margin: 0 10px 10px 0px;
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border: 1px dashed #ccc;
        border-radius: 3px;

        /deep/.el-upload {
          width: 60px;
          height: 60px;
        }

        img {
          width: 100%;
          height: 100%;
        }

        &:nth-child(even) {
          margin-right: 0;
        }

        &:nth-child(n + 2) {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>